module.exports = __webpack_public_path__ + "static/media/KnowledgeHiFi1.f454f261.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/KnowledgeHiFi1.png
// module id = 10
// module chunks = 0